import { Loader2 } from "lucide-react";
import React from "react";

const LoadingIndiator: React.FC = () => {
  return (
    <div className="flex h-[calc(100vh-64px)] w-full items-center justify-center">
      <Loader2 className="size-10 animate-spin text-primary" />
    </div>
  );
};

export default LoadingIndiator;
